import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { removePriceFilteringProfileEpic } from './_epics/removePriceFilteringProfile.epic';
import { createPriceFilteringProfileEpic } from './_epics/createPriceFilteringProfile.epic';
import { updatePriceFilteringProfileEpic } from './_epics/updatePriceFilteringProfile.epic';
import { loadPriceFilteringListEpic } from './_epics/loadPriceFilteringList.epic';
import { exportPriceFilteringProfileEpic } from './_epics/exportPriceFilteringProfile.epic';

export const priceFilteringEpic = safeCombineEpics(
  loadPriceFilteringListEpic,
  createPriceFilteringProfileEpic,
  updatePriceFilteringProfileEpic,
  removePriceFilteringProfileEpic,
  exportPriceFilteringProfileEpic,
);
